import React from 'react';
import { DivorceTextMin } from './DivorceText/DivorceTextMin';
import { DivorceTextMid } from './DivorceText/DivorceTextMid';
import { DivorceTextMax } from './DivorceText/DivorceTextMax';

export const DivorceContent = ({ packageName }) => {
  if (packageName === 'min') {
    return (
      <div className="divorce-info-content">
        <DivorceTextMin />
      </div>
    );
  }

  if (packageName === 'mid') {
    return (
      <div className="divorce-info-content">
        <DivorceTextMid />
      </div>
    );
  }

  return (
    <div className="divorce-info-content">
      <DivorceTextMax />
    </div>
  );
};
